import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface TimelineEventProps {
  event: {
    id: number;
    year: string;
    title: string;
    description: string;
    icon: string;
  };
  index: number;
  total: number;
}

const TimelineEvent = ({ event, index, total }: TimelineEventProps) => {
  return (
    <div className="relative flex items-start gap-6 group">
      <div className="flex flex-col items-center">
        <div className="relative z-10 w-14 h-14 rounded-full bg-gradient-to-br from-primary to-secondary flex items-center justify-center shadow-elevated group-hover:scale-110 transition-transform duration-300">
          <Icon name={event.icon as any} size={24} className="text-background" />
        </div>
        {index < total - 1 && (
          <div className="w-0.5 h-full bg-gradient-to-b from-primary/50 to-transparent mt-2"></div>
        )}
      </div>

      <div className="flex-1 pb-12">
        <div className="glassmorphic rounded-xl p-6 hover:shadow-premium transition-all duration-500 hover:-translate-y-1 shadow-silver-glow hover:shadow-orange-glow-hover card-3d-glow">
          <div className="text-sm font-mono text-primary mb-2">{event.year}</div>
          <h3 className="text-lg font-display font-bold text-foreground mb-3 group-hover:text-primary transition-colors duration-300">
            {event.title}
          </h3>
          <p className="text-sm text-muted-foreground leading-relaxed">
            {event.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TimelineEvent;